(() => {
  if (!/^es(?:-|$)/i.test(document.documentElement.lang)) return;
  const labels = new Map(Object.entries({"PRODUCT REGISTRATION":"REGISTRO DEL PRODUCTO","First Name":"Nombre","Last Name":"Apellidos","Email":"Correo electrónico","Country":"País","Please select":"Selecciona una opción","Product Name":"Nombre del producto","Order ID /#":"Número de pedido","Amazon Review Link":"Enlace a tu reseña de Amazon","Please upload your review proof of Amazon.":"Sube un justificante de tu reseña de Amazon.","Choose file or drag here":"Selecciona un archivo o arrástralo aquí","Supported format: JPG, JPEG, PNG, GIF, SVG.":"Formatos admitidos: JPG, JPEG, PNG, GIF, SVG.","Browse file":"Seleccionar archivo","Submit":"Enviar","Submitting...":"Enviando…","Next":"Siguiente","Previous":"Anterior","Back":"Volver","Remove":"Eliminar","Page 1":"Página 1","This field is required.":"Este campo es obligatorio.","This field is required":"Este campo es obligatorio.","Please enter a valid email address.":"Introduce una dirección de correo electrónico válida.","Please enter a valid email address":"Introduce una dirección de correo electrónico válida.","Please enter a valid URL.":"Introduce una dirección web válida.","File is too large":"El archivo es demasiado grande","Thank you for your submission!":"¡Gracias por enviar tus datos!","Your submission has been received.":"Hemos recibido tus datos."}
));
  const countries = new Map();
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z]/g, '');
  if (typeof Intl.DisplayNames === 'function') {
    const en = new Intl.DisplayNames(['en'], { type: 'region' });
    const de = new Intl.DisplayNames(['es'], { type: 'region' });
    for (let a = 65; a <= 90; a++) for (let b = 65; b <= 90; b++) {
      const code = String.fromCharCode(a, b), name = en.of(code);
      if (name !== code) countries.set(normalize(name), de.of(code));
    }
    const aliases = {
      'Antigua And Barbuda': 'AG', 'Bosnia And Herzegovina': 'BA',
      'Czech Republic': 'CZ', 'Turkey': 'TR', 'Saint Lucia': 'LC',
      'Saint Kitts And Nevis': 'KN', 'Saint Pierre And Miquelon': 'PM',
      'Trinidad and Tobago': 'TT', 'Turks and Caicos Islands': 'TC',
      'Wallis And Futuna': 'WF', 'Côte d’Ivoire': 'CI',
      'Virgin Islands, British': 'VG', 'Republic of Cameroon': 'CM',
      'Congo, The Democratic Republic Of The': 'CD', 'Congo': 'CG',
      "Côte d'Ivoire": 'CI', 'Guinea Bissau': 'GW', 'Iran, Islamic Republic Of': 'IR',
      "Lao People's Democratic Republic": 'LA', 'Libyan Arab Jamahiriya': 'LY',
      'Macao': 'MO', 'Moldova, Republic of': 'MD', 'Korea, Democratic People\'s Republic Of': 'KP',
      'Palestinian Territory, Occupied': 'PS', 'Reunion': 'RE', 'St. Vincent': 'VC',
      'Tanzania, United Republic Of': 'TZ', 'Timor Leste': 'TL',
      'United States Minor Outlying Islands': 'UM', 'Holy See (Vatican City State)': 'VA',
      'Saint Martin': 'MF', 'Saint Helena': 'SH', 'Saint Barthélemy': 'BL',
      'Sao Tome And Principe': 'ST', 'Falkland Islands (Malvinas)': 'FK',
      'Heard Island And Mcdonald Islands': 'HM', 'Svalbard And Jan Mayen': 'SJ',
      'South Georgia And The South Sandwich Islands': 'GS', 'Netherlands Antilles': 'AN'
    };
    for (const [name, code] of Object.entries(aliases)) countries.set(normalize(name), de.of(code));
    countries.set(normalize('Netherlands Antilles'), 'Antillas Neerlandesas');
  }
  const translate = root => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      if (node.parentElement?.closest('script, style, textarea, [contenteditable="true"]')) continue;
      const value = node.nodeValue.trim(), replacement = labels.get(value);
      if (replacement) node.nodeValue = node.nodeValue.replace(value, replacement);
    }
    for (const element of root.querySelectorAll('[placeholder], [aria-label]')) {
      for (const attr of ['placeholder', 'aria-label']) {
        const replacement = labels.get(element.getAttribute(attr));
        if (replacement) element.setAttribute(attr, replacement);
      }
    }
    for (const option of root.querySelectorAll('select option[value]')) {
      const replacement = countries.get(normalize(option.value));
      if (replacement && option.textContent !== replacement) option.textContent = replacement;
    }
  };
  let scheduled = false;
  const scan = () => {
    scheduled = false;
    document.querySelectorAll('.globo-formbuilder').forEach(translate);
  };
  const schedule = () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(scan); }
  };
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  scan();
})();